export function isTerminalOrder(order) {
  if (!order) {
    return false;
  }
  if (order.paymentStatus === "CANCELLED" || order.paymentStatus === "FAILED") {
    if (order.paymentRecoverable) {
      return false;
    }
    return true;
  }
  // WAITING_FUNDS is paid but still waiting — keep polling.
  if (
    order.paymentStatus === "SUCCESS" &&
    (order.fulfillmentStatus === "SUCCESS" ||
      order.fulfillmentStatus === "FAILED")
  ) {
    return true;
  }
  return false;
}

export function isWaitingForFunds(order) {
  return (
    order?.paymentStatus === "SUCCESS" &&
    order?.fulfillmentStatus === "WAITING_FUNDS"
  );
}

export const DEFAULT_SUPPORT_CONTACTS = {
  telegram: "https://t.me/tp_trendy_eng_shop",
  vk: "https://vk.ru/im?sel=-237118964",
  email: "navinking4c@rambler.ru",
};
